import { render, staticRenderFns } from "./SpcmStudentCounsellorTeam.vue?vue&type=template&id=22ba98dc&scoped=true"
import script from "./SpcmStudentCounsellorTeam.vue?vue&type=script&lang=js"
export * from "./SpcmStudentCounsellorTeam.vue?vue&type=script&lang=js"
import style0 from "./SpcmStudentCounsellorTeam.vue?vue&type=style&index=0&id=22ba98dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba98dc",
  null
  
)

export default component.exports